import React from 'react';
import { RefreshCw } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export interface QAStatCardProps {
  title: string;
  value: number | string;
  icon: React.ReactNode;
  iconBgClass: string;
  loading?: boolean;
  valueColorClass?: string;
  subtitle?: string;
  /** Optional mini-chart (e.g. quality sparkline) rendered under the value. */
  chart?: React.ReactNode;
}

export const QAStatCard: React.FC<QAStatCardProps> = ({
  title,
  value,
  icon,
  iconBgClass,
  loading = false,
  valueColorClass = '',
  subtitle,
  chart,
}) => (
  <Card className="bg-card/40">
    <CardContent className="p-3 sm:p-5">
      {loading ? (
        <div className="h-16 sm:h-20 flex items-center justify-center">
          <RefreshCw className="h-4 w-4 sm:h-5 sm:w-5 animate-spin text-muted-foreground" />
        </div>
      ) : (
        <div className="min-h-[4rem] sm:min-h-[5rem]">
          <div className="flex items-start justify-between gap-2">
            <p className="text-[10px] sm:text-[11px] font-medium uppercase tracking-[0.1em] text-muted-foreground truncate pt-1">
              {title}
            </p>
            <div className={`flex-shrink-0 p-2 rounded-lg border border-border ${iconBgClass}`}>
              {icon}
            </div>
          </div>
          <p className={`text-xl sm:text-3xl font-bold mt-1 ${valueColorClass}`}>{value}</p>
          {subtitle && (
            <p className="text-[10px] sm:text-xs text-muted-foreground mt-1">{subtitle}</p>
          )}
          {chart && <div className="mt-2">{chart}</div>}
        </div>
      )}
    </CardContent>
  </Card>
);
